export default "__VITE_ASSET__C6HdRR8a__"